import { Component, Input, OnInit, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { TooltipService } from './tooltip.service';
declare var jQuery: any;

@Component({
  selector: 'pru-tooltip',
  templateUrl: 'tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})

export class TooltipComponent implements OnInit, AfterViewInit, OnDestroy {
  tooltipWcmUrl: string = '';
  tooltipContent: string = 'Please refer to your contract for details about this particular field.';
  options: any = {
    animation: false,
    delay: {show:10, hide:0},
    html: true,
    trigger: 'focus'
  };
  @Input() definitionID: string;
  @Input() definitionLocation: string;
  @Input() clickTitle: string;
  @Input() placement: string;
  @Input() title: string;
  @Input() description: string; // Tooltip description if available. Optional.
  @Input() screenReaderText: string;
  @Input() analyticData: string;

  constructor(private _elementRef: ElementRef, private _tooltipService: TooltipService) { }

  ngOnInit(): void {
    this.screenReaderText = this.screenReaderText ? 'More info on ' + this.screenReaderText : '';
    this.tooltipWcmUrl = this._tooltipService.getTooltipWcmUrl(this.definitionID || '', this.definitionLocation || '', ((this.clickTitle && this.clickTitle.indexOf('/') !== -1) ? this.clickTitle.slice(0, this.clickTitle.indexOf('/')) : this.clickTitle) || '');
  }

  ngAfterViewInit(): void {
    this.options['placement'] = this.placement || 'bottom';
    this.options['title'] = this.title ? this.title + '<i class="fa fa-times pull-right cursor-pointer" aria-hidden="true"><span class="sr-only">Close</span></i>' : '<i class="fa fa-times pull-right cursor-pointer" aria-hidden="true"><span class="sr-only">Close</span></i>';
  }

  ngOnDestroy(): void { jQuery(this._elementRef['nativeElement']).popover('destroy'); }

  keyBoardActivate(eve){
   if(eve.key === "Enter"){
     this.getTooltipContent();
   }
  }
  getTooltipContent(): void {
    if (this.description) {
      this.tooltipContent = this.description;

      jQuery(this._elementRef['nativeElement']).find('[data-toggle="popover"]').popover(this.options).popover('toggle');

      return;
    }

    this._tooltipService.getTooltipData(this.tooltipWcmUrl).then((val) => {
      if (val){
        if(val['_body'] !== undefined && val['_body'] !== '') { 
          this.tooltipContent = val['_body'].replace(/&lt;/g, '<').replace(/&gt;/g, '>'); 
        } else {
          this.tooltipContent = val.replace(/&lt;/g, '<').replace(/&gt;/g, '>'); 
        }
      }
      jQuery(this._elementRef['nativeElement']).find('[data-toggle="popover"]').popover(this.options).popover('toggle');
    }, (error) => {
      if (error.status < 200 || error.status >= 305) {
        // console.error('Tooltip Error', error);
        jQuery(this._elementRef['nativeElement']).find('[data-toggle="popover"]').popover(this.options).popover('toggle');
      }
    });
  }

  isTooltipOpen(): boolean {
    if (this._elementRef.nativeElement.querySelector('[role="tooltip"]') === null) {
      return false;
    } else { return true; }
  }
}
